<template>
    <v-card class="py-8" color="primary darken-2">
        <div style="display:flex; align-items:center">
            <v-icon class="mr-2" color="secondary lighten-1">mdi-file-document-outline</v-icon>
            <h2 class="title-page" style="display:inline; font-weight: bold;font-size: 24px;line-height: 28px;">Consulta de dados sumários</h2>
        </div>
        <h4 class="mt-2 subtitle-page" style="font-style: normal;font-weight: 300;font-size: 16px;line-height: 20px;">Dados aprovados no controle de qualidade e agrupados em frequências determinadas (por hora, por dia e por mês).</h4>
        <selection-data-type
            :types="types"
            :stations="stations"
            :searchResult="searchResult"
            dataType="summary"
            formInformationMessage="Os dados disponibilizados variam de acordo com a  estação e a opção de sumário selecionado (por dia, por hora e por mês)."
            @changeDataType="changeDataType($event)"
            @searchStationData="searchStationData($event)"
        >
        </selection-data-type>

        <div v-if="searchResult">
            <search-result
                :searchResult="searchResult"
                :type="type"
                :types="types"
                :loadingOtherPeriod="loadingOtherPeriod"
                :loadingData="loadingData"
                @applyPeriod="applyPeriod($event)"
            >
            </search-result>
        </div>
    </v-card>
</template>

<script>
import moment from "moment-timezone";
import SearchResult from './SearchResult.vue'
import SelectionDataType from './SelectionDataType.vue'
export default {
    name:"SummariesData",
    props: {
        stations:{
            type: Array,
            required: true,
        },
        searchResult:{
            type: Object
        },
        loadingOtherPeriod:{
            type: Boolean
        },
        loadingData: {
            type: Boolean,
            default: false,
        }
    },
    components:{
        SelectionDataType,
        SearchResult,
    },
    data:()=>({
        types:[],
        type: undefined,
    }),
    created(){
        this.initialize();
    },
    methods:{
        initialize(){
            const hourlyType = this.createHourlyType();
            const dailyType = this.createDailyType();
            const monthlyType = this.createMonthlyType();
            this.types = [ hourlyType, dailyType, monthlyType ];
        },

        createHourlyType(){
            const hourlyType = {
                icon: "mdi-update",
                title: "Por hora",
                value: "horario",
            };
            const startDate = (moment.tz('America/Sao_Paulo').hours() > 0 ? moment.tz('America/Sao_Paulo').startOf("day") : moment.tz('America/Sao_Paulo').startOf("day").subtract(3, 'hours'));
            const finalDate = moment.tz('America/Sao_Paulo').startOf("hour");
            const subtitle = `De ${startDate.format("DD/MM/YYYY HH:mm")} a ${finalDate.format("DD/MM/YYYY HH:mm")}`;
            const date_start = startDate.utc().format();
            const date_end = finalDate.utc().format();
            return { ...hourlyType, subtitle, date_start, date_end };
        },

        createDailyType(){
            const dailyType = {
                icon: "mdi-calendar",
                title: "Por dia",
                value: "diario",
            };
            const startDate = moment().tz('America/Sao_Paulo').subtract(30, "days");
            const finalDate = moment().tz('America/Sao_Paulo');
            const subtitle = `De ${startDate.format("DD/MM/YYYY")} a ${finalDate.format("DD/MM/YYYY")}`;
            const date_start = startDate.format("YYYY-MM-DD");
            const date_end = finalDate.format("YYYY-MM-DD");
            return { ...dailyType, subtitle, date_start, date_end };
        },

        createMonthlyType(){
            const monthlyType = {
                icon: "mdi-calendar-month",
                title: "Por mês",
                value: "mensal",
            };
            const startDate = moment().tz('America/Sao_Paulo').subtract(12, "months");
            const finalDate = moment().tz('America/Sao_Paulo');
            const subtitle = `De ${startDate.locale("pt-br").format("MMMM/YYYY")} a ${finalDate.locale("pt-br").format("MMMM/YYYY")}`;
            const date_start = startDate.format("YYYY-MM");
            const date_end = finalDate.format("YYYY-MM");
            return { ...monthlyType, subtitle, date_end, date_start };
        },

        changeDataType(dataType){
            this.type = dataType.value;
            this.$emit("changeDataType", dataType);
        },

        searchStationData(searchStationDataParams){
            this.$emit("searchStationData", { ...searchStationDataParams });
        },

        applyPeriod(periodSelected){
            this.$emit("applyPeriod", periodSelected);
        }
    }
}
</script>

<style scoped>
    .v-tab{
        text-transform: none;
    }
</style>
